import React, { useMemo } from "react"
import { DebouncedFilterInput } from "./DebouncedFilterInput"
import {
    RankingInfo,
    rankItem,
    compareItems,
} from '@tanstack/match-sorter-utils'
import { sortingFns } from "@tanstack/react-table"
import { GetEventLabelValueFn } from "../../EventLabel"
export const fuzzyFilter = (row, columnId, value, addMeta) => {
    // Rank the item
    const itemRank = rankItem(row.getValue(columnId), value)
    // Store the itemRank info
    addMeta({
        itemRank,
    })
    // Return if the item should be filtered in/out
    return itemRank.passed
}

export const fuzzySort = (rowA, rowB, columnId) => {
    let dir = 0

    // Only sort by rank if the column has ranking information
    if (rowA.columnFiltersMeta[columnId]) {
        dir = compareItems(rowA.columnFiltersMeta[columnId]?.itemRank, rowB.columnFiltersMeta[columnId]?.itemRank)
    }

    // Provide an alphanumeric fallback for when the item ranks are equal
    return dir === 0 ? sortingFns.alphanumeric(rowA, rowB, columnId) : dir
}

export const TableFilter = ({ column, table, eventLabels, environment, updateEventLabels }) => {
    const firstValue = table
        .getPreFilteredRowModel()
        .flatRows[0]?.getValue(column.id)

    const columnFilterValue = column.getFilterValue()

    const sortedUniqueValues = useMemo(
        () =>
            typeof firstValue === 'number'
                ? []
                : Array.from(column.getFacetedUniqueValues().keys()).sort(),
        [column.getFacetedUniqueValues()]
    )
    const searchFieldPlaceholder = useMemo(() => {
        return GetEventLabelValueFn({ name: "SearchPlaceholder", groupName: "CMS.Table" }, eventLabels, environment, updateEventLabels)
    }
        , [eventLabels])
    return <>
        {/* <datalist id={column.id + 'list'}>
            {sortedUniqueValues.slice(0, 5000).map((value) => (
                <option value={value} key={value} />
            ))}
        </datalist> */}
        <DebouncedFilterInput
            type="text"
            value={columnFilterValue ?? ''}
            onChange={value => column.setFilterValue(value)}
            placeholder={searchFieldPlaceholder}
            className="search-input"
            // list={column.id + 'list'}
        />
    </>
}
